import { render, staticRenderFns } from "./wedding.vue?vue&type=template&id=951e9eb2&scoped=true"
import script from "./wedding.vue?vue&type=script&lang=js"
export * from "./wedding.vue?vue&type=script&lang=js"
import style0 from "./wedding.vue?vue&type=style&index=0&id=951e9eb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951e9eb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('951e9eb2')) {
      api.createRecord('951e9eb2', component.options)
    } else {
      api.reload('951e9eb2', component.options)
    }
    module.hot.accept("./wedding.vue?vue&type=template&id=951e9eb2&scoped=true", function () {
      api.rerender('951e9eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/wedding.vue"
export default component.exports